/**
 * Format phone number using country code and national number to specification for userreadserv alias
 * (unfortunately Griffin does not offer any formatting that is compatible with userreadserv search)
 * We also use this formatting to pull out phone numbers from contacts (e.g. in findRecipientInContacts)
 * @param {CanonicalPhoneNumber} phone - canonical phone number
 * @param {string} phone.countryCode - phone number country code (e.g. +1)
 * @param {string} phone.nationalNumber - national number with no non-numeric characters (e.g. spaces, hyphens, etc.)
 * @returns {string} formatted phone number for use with userreadserv search via alias
 */
export function formatAliasPhoneNumber({
  countryCode,
  nationalNumber,
}: CanonicalPhoneNumber) {
  if (nationalNumber) {
    return `+${countryCode || 1} ${nationalNumber}`
  }

  return ''
}
